export default __webpack_public_path__ + "static/media/attachment.56b1c6ef.png";